import SquareIcon from '@mui/icons-material/Square';
import { createColumnHelper } from '@tanstack/react-table';
import { L } from 'harmony-language';
import React from 'react';
import { Medication } from '../../../types';
import CheckIcon from '@mui/icons-material/Check';

export const useMedicationColumns = () => {
    const columnHelper = createColumnHelper<Medication>();

    const columns = React.useMemo(() => ([
        columnHelper.accessor('name', {
            header: L.name(),
            cell: (info) => info.getValue(),
            enableColumnFilter: false,
        }),
        columnHelper.accessor('hexColor', {
            header: L.color(),
            cell: (info) => <SquareIcon style={{ color: info.getValue() }} />,
            enableColumnFilter: false,
            enableSorting: false,
        }),
        columnHelper.accessor((medication) => {
            return medication.requiresFlush ? L.true() : L.false();
        }, {
            header: L.requiresFlush(),
            cell: (info) => info.row.original.requiresFlush && <CheckIcon color='primary' />,
            enableSorting: false,
        }),
    ]), []);

    return columns;
}
